import React from "react";
import { isApiFileUrl, resolveFileUrl } from "../../utils/fileUrl";

type AppAudioProps = Omit<
  React.AudioHTMLAttributes<HTMLAudioElement>,
  "src" | "crossOrigin"
> & {
  src?: string | null;
};

/**
 * `<audio>` wrapper. Resolves `src` against the runtime backend host and
 * attaches `crossOrigin="use-credentials"` when the resolved URL is an API
 * file URL so the bpreven.auth cookie authenticates the request.
 */
const AppAudio: React.FC<AppAudioProps> = ({ src, ...rest }) => {
  const resolved = resolveFileUrl(src);
  const crossOrigin = isApiFileUrl(resolved) ? "use-credentials" : undefined;
  return <audio src={resolved} crossOrigin={crossOrigin} {...rest} />;
};

export default AppAudio;
